import React from "react";
import { Flex, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const SiteLinks = (): JSX.Element => {
  const links = [
    {
      label: "Blog",
      url: "https://medium.com/@manishparui",
    },
    {
      label: "Projects",
      url: "/projects",
    },
    {
      label: "Tools",
      url: "/tools",
    },
    {
      label: "Contact",
      url: "/tools",
    },
  ];
  return (
    <Flex gap={6}>
      {links.map((link) => (
        <Button
          key={link.label}
          as={Link}
          variant={"link"}
          to={link.url}
          color={"neonDefault"}
          gap={3}
        >
          {link.label}
        </Button>
      ))}
    </Flex>
  );
};

export default SiteLinks;
